export const reviews = [
  {
    name: "Marianna",
    review:
      "Such a great experience getting tattooed by Marlena. She has such a welcoming, nonjudgmental energy and creates a really calming, comfortable environment. Her space is beautiful and full of cool art and decor, so there’s always something interesting to look at while getting tattooed. She’s also an incredibly talented artist with amazing attention to detail. Highly recommend",
  },
  {
    name: "Sabrina",
    review:
      "Marlena is the best tattoo artist I’ve been to by far. Her attention to detail succeeded all my expectations. During our 4 hour appointment I felt extremely comfortable and heard. Not only is she beyond talented but her kindness to her clients and other guests make me know I chose the right artist. She will definitely have a forever client!",
  },
  {
    name: "Alex",
    review:
      "Genuinely the most welcoming space I have ever been in. It’s always such a wonderful experience. Marléna is literally an angel every time I have been tattooed by her I have loved every moment and every piece. I cannot recommend these two enough. Amazing care and space 10000/10 💕",
  },
  {
    name: "Allison",
    review:
      "Marléna is the absolute best!! I have gotten several tattoos from her now and she is so incredibly talented. Her space at Holy Fool is clean and inviting, and she goes out of her way to work with you and make you feel comfortable. Recommending her always!!",
  },
  {
    name: "Rachel",
    review:
      "This is one of the most comfortable tattoo places I've ever been to! Their decor is awesome and I love that it's tucked back, away from more crowded areas of ABQ. Marlena is an absolutely amazing tattoo artist. Her fine line work, attention to detail, gentle hand, and mix of friendliness and professionalism surpass other tattoo artists and shops I've been to.",
  },
  {
    name: "Gabrielle",
    review:
      "Amazing experience from the start. My two friends and I were interested in getting ornamental fine line tattoos while on a trip to New Mexico. We found Marlena online and loved all of her work. She sketched something unique that incorporated all of what we wanted and thoroughly worked with us to customize the design to fit our anatomy. One of the most positive experiences I have had getting tattooed.",
  },
  {
    name: "Seth",
    review:
      "Marlena did such a fantastic job on my first tattoo in 9 years! She always does great work for my girlfriend, too! She’s super patient, takes her time with her work, and is really nice! Love this little shop!",
  },
  {
    name: "Miranda",
    review:
      "Marléna is fantastic! She is so patient when working with design and placement. Fine line was very important to us and she did it flawlessly!",
  },
  {
    name: "Hannah",
    review:
      "Marlena was fantastic!! Very accommodating when it came to placement and design. My friends and I got friendship tattoos that were different in appearance, style, and size and she made us feel so comfortable with all our questions. All around such a great experience!",
  },
  {
    name: "Mae",
    review:
      "Marlena is wonderful! She is so patient and her work is beautiful, it’s exactly what I wanted. The energy in the shop is also great, I felt very comfortable and enjoyed my time there.",
  },
  {
    name: "Olivia",
    review:
      "Marlena did a fantastic job for my first tattoo! She was very patient with me, my thoughts and my questions! Would recommend for a first time tattoo-ee!",
  },
  {
    name: "Peyton",
    review:
      "I’ve been able to be tattooed by Marléna two times now and both times were amazing experiences! Beautiful designs that were exactly what I wanted made even better with her style. Both tattoos have healed flawlessly. Marléna is so easy to talk to and makes the whole experience that much more enjoyable.",
  },
];